module.exports = __webpack_public_path__ + "static/img/yamamoto_04.8abcef0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yamamoto_04.jpg
// module id = hTIq
// module chunks = 0